$('.seating-chart-wrapper .options-wrapper .option').on('click', (e) => {
  e.preventDefault()
  let pkg_type = e.target.dataset['filter']

  $('.filter-container .buttons-wrapper li').each((i, elem) => {
    if (elem.dataset['filter'] == pkg_type) $(elem).find('.switch input').click()
  })
})
